import type { BackendRouteDefinition } from '../types';
import type { SendEmployeeInvite } from '@cloudFunctions/types/firms/sendEmployeeInvite';
import { withIdempotencyKeyHeader } from '../../../../../shared/backend/routes/idempotency';
import { buildDeterministicIdempotencyKey } from './buildDeterministicIdempotencyKey';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S6-WB2
// (PRA-795). Now served by `api-core-node` at
// `POST /api/firms/employees/:userId/invitations`.
//
// The route ships a deterministic Idempotency-Key derived from the request
// data (`userId`). The server scopes the durable reservation by tenant,
// so two firms with a collision-class userId never share a reservation —
// see `services/api-core-node/src/routes/plugins/employees.ts` for the
// reservation/completed TTL rationale.
export const sendEmployeeInviteRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/employees/:userId/invitations',
  params: ({ userId }: SendEmployeeInvite.Props) => ({ userId }),
  body: () => ({}),
  headers: (requestData: SendEmployeeInvite.Props) =>
    withIdempotencyKeyHeader({
      idempotencyKey: buildDeterministicIdempotencyKey({
        prefix: 'send-employee-invite',
        requestData,
      }),
    }),
} as const satisfies BackendRouteDefinition;
